
function applyListeners() {
	document.querySelectorAll<HTMLInputElement>('.verificationDocumentUploadAndManagementForm input[type="file"]:not(.connected)').forEach(fileField => {
		fileField.classList.add("connected");
		fileField.addEventListener('change', () => {
			let parent: HTMLElement = fileField;
			do {
				parent = parent.parentElement;
			} while (!parent.classList.contains("documentManagingForm") && parent !== fileField.form);
			parent.querySelector<HTMLElement>('.btn.submit input').click();
		});
	});
}
export function init() {
	applyListeners();
	document.addEventListener("jsfAjaxEvent", applyListeners);
}
